export default{chip:"w_8",selected:"w_9",small:"w_AA",large:"w_AB",leading:"w_AC",trailing:"w_AD"};
